import { useEffect, useState } from 'react';

import useSymptomChecker from 'hooks/useSymptomChecker';
// import { checkSpanishLocale } from 'lib/utils';
import { useSymptomStore } from 'store/symptom';
import SymptomContainer from './components/SymptomContainer';
import ImageUpload from './ImageUpload';
import { usePostSymptomFileUpload } from 'services/symptom-checker/hooks';
import toast from 'react-hot-toast';
import Loader from 'components/Loader';
import { useTranslation } from 'react-i18next';

function getFilenameFromUrl(url: any) {
  return url.split('/').pop().split('?')[0];
}

async function urlToFile(url: string) {
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('Failed to fetch the image');
  }

  const contentType =
    response.headers.get('Content-Type') || 'application/octet-stream';
  const blob = await response.blob();

  const filename = getFilenameFromUrl(url);

  return new File([blob], filename, { type: contentType });
}

export default function SymptomFileUpload() {
  const { t } = useTranslation();
  const questionData = useSymptomStore((store) => store.questionData)?.data;

  // const isSpanish = checkSpanishLocale();

  const { onSubmit } = useSymptomChecker();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [files, setFiles] = useState<File[]>([]);
  // const [uploadedImages, setUploadedImages] = useState<
  //   { id: string; url: string }[]
  // >([]);

  // const englishChoices = JSON.parse(questionData?.eng_choices || '[]');
  // const spanishChoices = JSON.parse(questionData?.spanish_choices || '[]');

  useEffect(() => {
    (async () => {
      if (
        questionData?.user_eng_choices ||
        questionData?.user_spanish_choices
      ) {
        const images = questionData?.image_url;
        if (images?.length) {
          setIsFetching(true);
          try {
            console.log('🚀 ~ SymptomFileUpload ~ images:', images);
            const files = await Promise.all(
              images.map(async (img) => await urlToFile(img.url))
            );
            console.log('🚀 ~ SymptomFileUpload ~ files:', files);
            // setUploadedImages(images);
            setFiles(files);
          } catch (error) {
            console.log('🚀 ~ SymptomFileUpload ~ error:', error);
          } finally {
            setIsFetching(false);
          }
        }
      }
    })();
  }, [questionData]);

  const { mutate } = usePostSymptomFileUpload({
    onSuccess: async (data) => {
      console.log(data);
      //  const imagesWithIdToken = uploadedImages
      //    .filter((image) => image.id)
      //    ?.map((image) => image.id);
      const uploadedTokens = data.map((item) => item.token_id);
      //  const tokens = [...(uploadedTokens || []), ...(imagesWithIdToken || [])];
      const tokens = [...(uploadedTokens || [])];
      await onSubmit({
        eng_choices: JSON.stringify(tokens),
        spanish_choices: JSON.stringify(tokens),
        questionData,
      });
      setIsLoading(false);
    },
    onError: () => {
      toast.error(t('failed_to_upload_images'));
      setIsLoading(false);
    },
  });

  const onContinue = () => {
    if (!files?.length) {
      onSubmit({
        eng_choices: JSON.stringify([]),
        spanish_choices: JSON.stringify([]),
        questionData,
      });
      return;
    }

    // const imagesWithId = uploadedImages.filter((image) => image.id);
    // if (imagesWithId?.length) {
    //   const tokens = imagesWithId.map((image) => image.id);
    //   onSubmit({
    //     eng_choices: JSON.stringify(tokens),
    //     spanish_choices: JSON.stringify(tokens),
    //     questionData,
    //   });
    //   return;
    // }

    setIsLoading(true);
    const formData = new FormData();
    // const nonUploadedImages = uploadedImages.filter((image) => !image.id);
    files.forEach((file) => {
      formData.append('file', file);
    });

    mutate(formData);
  };

  return (
    <SymptomContainer
      questionData={questionData}
      isLoading={isLoading}
      onContinue={onContinue}
      questionNumber={7}
    >
      {isFetching ? (
        <Loader className='h-60' loaderSize='size-8' />
      ) : (
        <>
          <p className='mb-2 text-sm md:text-base'>
            {t('symptom_file_upload_message')}
          </p>
          <ImageUpload files={files} setFiles={setFiles} />
        </>
      )}
    </SymptomContainer>
  );
}
